import ReviewCard from './ReviewCard';

export default ReviewCard;
